import { render, staticRenderFns } from "./Jointrader.vue?vue&type=template&id=66d6936a"
import script from "./Jointrader.vue?vue&type=script&lang=js"
export * from "./Jointrader.vue?vue&type=script&lang=js"
import style0 from "./Jointrader.vue?vue&type=style&index=0&id=66d6936a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UserCountry: require('/root/workspace/web-company_Yo6Q/components/userLogin/userCountry.vue').default})
